import LibraryManager from './LibraryManager';
import { adminApi } from '../../lib/api';
import { SafetyFieldset } from './SafetyFieldset';

const CATEGORIES = ['care', 'medical', 'education', 'legal', 'financial', 'other'];

const AdminDocumentTypes = () => (
  <LibraryManager
    title="Document types"
    description="Controlled vocabulary the AI uses to classify each segment of an SAR response."
    testIdPrefix="doc-types"
    categories={CATEGORIES}
    api={{
      list: (params) => adminApi.listDocTypes(params),
      create: (d) => adminApi.createDocType(d),
      update: (id, d) => adminApi.updateDocType(id, d),
      delete: (id) => adminApi.deleteDocType(id),
      approve: (id, d) => adminApi.approveDocType(id, d),
      reject: (id) => adminApi.rejectDocType(id),
    }}
    labels={{
      singular: 'document type',
      plural: 'document types',
      name: 'Name',
      search: 'Search by name or description…',
    }}
    extraFields={[
      { key: 'sub_type', label: 'Sub-type (optional)', type: 'text', placeholder: 'e.g. annual review' },
      { key: 'statutory_basis', label: 'Statutory basis (optional)', type: 'text', placeholder: 'e.g. Care Planning Regs 2010' },
      { key: 'icon', label: 'Icon (lucide name)', type: 'text', placeholder: 'e.g. FileText, ClipboardList, Stethoscope' },
      { key: 'label_template', label: 'Card label template', type: 'textarea', placeholder: 'e.g. "LAC Review with [social_worker] at [organisation]". Tokens: [organisation] [date] [people] [social_worker] [iro] [teacher] [foster_carer] [doctor] [location] [placement_location] [year_group] [court_name] [school_name] [practice_name]' },
      {
        key: 'emotional_safety',
        render: (editing, setEditing, testIdPrefix) => (
          <SafetyFieldset editing={editing} setEditing={setEditing} testIdPrefix={testIdPrefix} />
        ),
      },
    ]}
  />
);

export default AdminDocumentTypes;
